import { useQuery } from '@tanstack/react-query'

import fetchRequest from '@/app/_utils/fetch-request'

import { PDPReactQueryKeys } from '../types'

export const useGetWishlist = (id: string, isLoggedIn: boolean) => {
    return useQuery({
        queryKey: [PDPReactQueryKeys.Wishlist, { id }],
        queryFn: async () =>
            fetchRequest({
                serviceName: 'ntl',
                method: 'GET',
                endpoint: `/wishlist/product-id/${id}`,
            }),
        enabled: !!id && isLoggedIn,
    })
}
